export const normalizePickupId = (pickupId?: string | null) =>
  pickupId?.toUpperCase?.() ?? pickupId;

export const normalizeShipperCode = (shipperCode?: string | null) =>
  shipperCode?.toUpperCase?.() ?? shipperCode;

export const pickupIdsMatch = (left?: string | null, right?: string | null) =>
  normalizePickupId(left) === normalizePickupId(right);
